"use client";

import { EmployButtonTrackedClickEvent } from "@homeinstead/analytics";
import { cn } from "@homeinstead/ui";
import { Button } from "@homeinstead/ui/components/Button";
import { usePathname, useRouter } from "next/navigation";
import { useSetQueryParam } from "~www/hooks/useSetQueryParam";

export type ApplyToBeACareGiverButtonVariant = "plain" | "primary" | "friendly";

const VARIANT_STYLES: Record<ApplyToBeACareGiverButtonVariant, string> = {
  friendly: "",
  plain: "h-fit p-0 underline hover:no-underline",
  primary: "",
};

export const ApplyToBeACareGiverButton = ({
  children,
  className,
  variant = "plain",
}: {
  children: React.ReactNode;
  className?: string;
  variant?: ApplyToBeACareGiverButtonVariant;
}) => {
  const createQueryString = useSetQueryParam();
  const pathname = usePathname();
  const router = useRouter();

  const trackCareGiverClick = () => {
    EmployButtonTrackedClickEvent();
  };

  const handleCaregiverClick = (e: React.MouseEvent) => {
    e.preventDefault();

    trackCareGiverClick();

    const queryString = createQueryString("leadVariant", "CareGiver");
    const newPath = `${pathname}?${queryString}`;

    router.push(newPath);
  };

  return (
    <Button
      className={cn(VARIANT_STYLES[variant], className)}
      onClick={handleCaregiverClick}
      type="button"
      variant={variant}
    >
      {children}
    </Button>
  );
};
